// Resolve a stored image URL to something origin-independent.
// Historically some uploads were saved with the preview host baked in
// (https://<pod>.emergentagent.com/api/files/...). Strip any *.emergentagent.com
// host off an /api/files path so it becomes relative and resolves against whatever
// domain is serving the site (preview OR production). External URLs pass through.
const PLACEHOLDER = "/placeholder-vehicle.svg";

export function resolveImageUrl(url, fallback = PLACEHOLDER) {
  if (!url || typeof url !== "string") return fallback;
  const m = url.match(/^https?:\/\/[^/]+\.emergentagent\.(?:com|host)(\/api\/files\/.*)$/i);
  if (m) return m[1];
  return url;
}
